import Listing from "../Listing";
import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchlessonMaterialscience } from "../../../redux/action/lessonsAction";
import SecureContent from "../../../components/secureContent";

const MaterialScience = () => {
  const dispatch = useDispatch();
  const { materialscienceList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonMaterialscience());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Materials Science and Robot Combat"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: pageRoutes?.home },
            {
              name: "Materials Science and Robot Combat",
              path: pageRoutes?.home,
            },
          ]}
        />

        <Listing contentData={materialscienceList} color={"#36296c"} />

        <Footer />
      </div>
    </>
  );
};

export default MaterialScience;
